import { TeamMember } from "../types";

// Define team members for email signoff
export const TEAM_MEMBERS: TeamMember[] = [
  { id: 2, name: "Ng Min Jie (MJ)", mobile: "9144 0870" },
  { id: 3, name: "Helen Chee (Helen)", mobile: "9025 2867" },
  { id: 4, name: "Keane Lim", mobile: "9855 1686" },
  { id: 5, name: "S Arshad Ahmed (Arshad)", mobile: "83228174" },
  { id: 6, name: "Robert Lim", mobile: "9230 9969" },
  { id: 7, name: "Lim Yen San", mobile: "97984238" },
];
